(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientLead',
	};

	var total_contacts   = 1,
	    contacts_element = $('select#clientlead-contacts_number');


	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		handleContacts();
		handleSameAddressCheckbox();
		handleSameEmailChecked();
		handleSpecialOccasionValue();
		handleSpecialNeedsChecked();
		handleTripTypeBrandSelection();

		// this will prevent the drowdown header to change.
		$form.on('shown.bs.select', function optgroupSelectAll(e) {
			e.stopPropagation();
		});
	};

	/**
	 * Handles the contacts dropdown
	 */
	function handleContacts()
	{
		if (contacts_element.length === 0) {
			return;
		}

		contacts_element.change(function changed(e) {
			let contacts_count = contacts_element.val();

			if (contacts_count < total_contacts) {
				let amount_to_remove = total_contacts - contacts_count;
				handleContactRemoval(amount_to_remove);
			} else {
				let amount_to_add = contacts_count - total_contacts;
				handleContactAdd(amount_to_add);
			}
		});
	}

	/**
	 * Handler for when a contact is removed
	 * @param amount_to_remove the amount of contacts to be removed
	 */
	function handleContactRemoval(amount_to_remove)
	{
		let temp = amount_to_remove;

		while (temp > 0) {
			$('#client_contact_' + total_contacts).addClass('hidden d-none');
			$('#client_contact_'+ total_contacts + ' fieldset').attr('disabled', 'disabled');
			$('#client_contact_'+ total_contacts + ' .clone_address_checkbox').attr('disabled', 'disabled');
			temp--;
			total_contacts--;
		}
	}
	/**
	 * Handles new adding new contacts
	 * @param amount_to_add
	 */
	function handleContactAdd(amount_to_add)
	{
		let new_total = total_contacts+amount_to_add;

		for (let i = total_contacts; i < new_total; i++) {
			let next_element_count       = i+1;
			let default_element_selector = 'client_contact_' + next_element_count;
			let element_selector         = $('#' + default_element_selector);

			if (element_selector.hasClass('hidden') || element_selector.hasClass('d-none')) {
				element_selector.removeClass('hidden d-none');
				$('#' + default_element_selector + ' fieldset').removeAttr('disabled');
				$('#' + default_element_selector + ' .clone_address_checkbox').removeAttr('disabled');
			}
		}

		total_contacts = new_total;
	}

	/**
	 * Function handles the special occasion field being changed to "Other"
	 */
	function handleSpecialOccasionValue()
	{
		$(document).on('change', '.special-occasion', function toggleOtherField() {
			let special_occasion                         = $(this).val();
			let special_occasion_other_fieldset_selector = $('#client_contact_' + $(this).attr('attr-number') + ' #special_occasion_other_fieldset');

			if (special_occasion === 'Other') {
				special_occasion_other_fieldset_selector.removeClass('hidden d-none');
			} else {
				special_occasion_other_fieldset_selector.addClass('hidden d-none');
			}
		});
	}

	/**
	 * Function handles the same address as primary contact checkbox
	 */
	function handleSameAddressCheckbox()
	{
		$(document).on('click', '.clone_address_checkbox', function clicked() {
			let address_element_selector  = $('#client_contact_' + $(this).attr('attr-number') + ' .lead_form_address');
			let address_fieldset_selector = $('#client_contact_' + $(this).attr('attr-number') + ' #address_fieldset');
			let required_email_selector   = $('#required_icon-' + $(this).attr('attr-number') + '-email');

			if ($(this).is(':checked')) {
				address_element_selector.addClass('hidden d-none');
				required_email_selector.addClass('hidden d-none');
				address_fieldset_selector.attr('disabled', 'disabled');
			} else {
				address_element_selector.removeClass('hidden d-none');
				required_email_selector.removeClass('hidden d-none');
				address_fieldset_selector.removeAttr('disabled');
			}
		});
	}

	/**
	 * Function handles the same email as primary checkbox
	 */
	function handleSameEmailChecked() {
		$(document).on('click', '.clone_email_checkbox', function onSameEmailClick() {
			let address_element_selector = $('#clientlead-lead_form-' + $(this).attr('attr-number') + '-email');

			if ($(this).is(':checked')) {
				address_element_selector.attr('disabled', 'disabled');
				address_element_selector.parent().addClass('hidden d-none');
			} else {
				address_element_selector.removeAttr('disabled');
				address_element_selector.parent().removeClass('hidden d-none');
			}
		});
	}

	/**
	 * Function handles the special needs checkbox
	 */
	function handleSpecialNeedsChecked() {
		$(document).on('click', '.special-needs', function onSpecialNeedsClick() {
			let special_needs_details_fieldset_selector = $('#client_contact_' + $(this).attr('attr-number') + ' #special_needs_details_fieldset');

			if ($(this).is(':checked')) {
				special_needs_details_fieldset_selector.removeClass('hidden d-none');
			} else {
				special_needs_details_fieldset_selector.addClass('hidden d-none');
			}
		});
	}

	/**
	 * When a Trip Type is selected, show the brand dropdown filtered
	 * to only the brands that belong to that trip type.
	 * Brand data is pre-loaded as window.LEAD_FORM_BRANDS_BY_TRIP_TYPE.
	 */
	function handleTripTypeBrandSelection() {
		// Trip types that should NOT show a brands dropdown
		var noBrandsTripTypes = [
			'Custom Designed Trip',
			'Custom Designed Trips',
			'Unsure/Open to Ideas'
		];

		$(document).on('change', '.lead-trip-type', function onTripTypeChange() {
			let tripType       = $(this).val();
			let contactNumber  = $(this).attr('attr-number');
			let $fieldset      = $('#client_contact_' + contactNumber + ' #brand_preference_fieldset');
			let $brandSelect   = $fieldset.find('#brand-preference-select');
			let brandsMap      = window.LEAD_FORM_BRANDS_BY_TRIP_TYPE || {};
			let brands         = brandsMap[tripType] || {};
			let brandKeys      = Object.keys(brands);

			$brandSelect.empty();

			// Hide for empty selection or trip types that should not show brands
			if (!tripType || noBrandsTripTypes.indexOf(tripType) !== -1) {
				$fieldset.addClass('hidden d-none');
				return;
			}

			// If no brands mapped for this trip type, hide the fieldset
			if (brandKeys.length === 0) {
				$fieldset.addClass('hidden d-none');
				return;
			}

			$brandSelect.append('<option value="">Please Select</option>');

			$.each(brands, function appendBrand(value, label) {
				$brandSelect.append('<option value="' + $('<div/>').text(value).html() + '">' + $('<div/>').text(label).html() + '</option>');
			});

			$fieldset.removeClass('hidden d-none');
		});
	}
}(jQuery, window.Adzuki || {}));
